var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"smole-padding",attrs:{"depressed":"","color":"deletecolor","disabled":_vm.disabled},on:{"click":_vm.del}},[_c('span',{staticClass:"material-icons smole-size"},[_vm._v("delete_outline")]),_vm._v("削除")])}
var staticRenderFns = []

export { render, staticRenderFns }